import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import Logo from "../components/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await login(email, password); nav("/"); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden bg-[#0E0E1C]">
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#4A00E0] opacity-30 blur-[120px]" />
        <div className="absolute bottom-0 right-0 h-[420px] w-[420px] rounded-full bg-[#A855F7] opacity-20 blur-[120px]" />
        <div className="relative"><Logo dark size={44} /></div>
        <div className="relative max-w-lg">
          <h1 className="text-5xl font-extrabold text-white leading-[1.05]">Every album, lead and rupee — <span className="vmw-gradient-text">in one place.</span></h1>
          <p className="text-slate-400 mt-5 text-base">The business command centre for Vayora Media Works. Sales, production and finance, secured by role.</p>
        </div>
        <div className="relative flex items-center gap-2 text-xs text-slate-500"><ShieldCheck className="h-4 w-4 text-violet-400" /> Role-based access · Server-side permissions · Audit trail</div>
      </div>
      <div className="flex items-center justify-center p-6 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="mb-8"><Logo size={40} /></div>
          <h2 className="text-3xl font-bold text-[#1A1A2E]">Sign in</h2>
          <p className="text-sm text-muted-foreground mt-1 mb-8">Use the account created for you by the owner.</p>
          <label className="block text-xs font-semibold text-slate-600 mb-1">Email</label>
          <input data-testid="login-email-input" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="vmw-input h-11 mb-4" placeholder="you@vayora.com" />
          <label className="block text-xs font-semibold text-slate-600 mb-1">Password</label>
          <input data-testid="login-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="vmw-input h-11" />
          {err && <div data-testid="login-error" className="mt-4 text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-md px-3 py-2">{err}</div>}
          <button data-testid="login-submit-button" disabled={busy} className="mt-6 w-full h-11 rounded-full vmw-gradient text-white font-semibold flex items-center justify-center gap-2 hover:opacity-95 transition-opacity disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
          <p className="text-xs text-muted-foreground mt-6">No public sign-up. <Link to="/forgot-password" className="text-primary font-semibold" data-testid="forgot-password-link">Forgot password?</Link></p>
        </form>
      </div>
    </div>
  );
}
